import { FC, ReactNode } from 'react';

import InfoClick from 'bloko/blocks/drop/Info/Click';

import styles from 'components/Banner/Preview/PreviewTip/PreviewTip.module.less';

interface PreviewTip {
    tipText: string;
    dataQA?: string;
    children: ReactNode;
}

const PreviewTip: FC<PreviewTip> = ({ tipText, dataQA, children }) => (
    <InfoClick render={() => <p className={styles.bannerPreviewTip}>{tipText}</p>}>
        <div data-qa={dataQA}>{children}</div>
    </InfoClick>
);

export default PreviewTip;
